import {
  SET_AVAILABLE_METRICS,
  SET_METRICS,
  SET_DIAGNOSTICS
} from ":mutations";
import {
  REQUEST_AVAILABLE_METRICS,
  REQUEST_METRICS,
  REQUEST_DIAGNOSTICS
} from ":actions";

import http from ":http";

const state = {
  availableMetrics: [],
  metrics: {
    name: "",
    description: "",
    baseUnit: "",
    measurements: [],
    availableTags: []
  },
  diagnostics: ""
};

const mutations = {
  [SET_AVAILABLE_METRICS](state, { metrics }) {
    state.availableMetrics = metrics;
  },

  [SET_METRICS](state, { metrics }) {
    state.metrics = metrics;
  },

  [SET_DIAGNOSTICS](state, { diagnostics }) {
    state.diagnostics = diagnostics;
  }
};

const actions = {
  [REQUEST_AVAILABLE_METRICS]({ commit }) {
    return http.get("/management/metrics").then(response =>
      commit(SET_AVAILABLE_METRICS, {
        metrics: response.data.names
      })
    );
  },

  [REQUEST_METRICS]({ commit }, { name, tags }) {
    return http
      .get(`/management/metrics/${name}`, { params: tags })
      .then(response => {
        commit(SET_METRICS, {
          metrics: response.data
        });

        return response;
      });
  },

  [REQUEST_DIAGNOSTICS]({ commit }, { query }) {
    return http.get(`/management${query}`).then(response =>
      commit(SET_DIAGNOSTICS, {
        diagnostics: response.data
      })
    );
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
